import InnsworthList from "components/list/list";
import InnsworthSlider from "../../components/slider/slider";
import { useCallback, useEffect, useState } from "react";
import { filesHttpService, newsHttpService } from "@myinnsworth/httpServices";
import { ICardProps } from "components/card/card";
import INewsArticle, { NewsArticleType } from "@myinnsworth/models/news/INewsArticle";
import noNewsPlaceholder from '../../assets/images/no-news-placeholder.png';
import { useNavigate, useOutletContext } from "react-router";
import { DashboardLayoutContext } from "containers/layouts/dashboard/dashboard";
import { ListMode } from "@myinnsworth/models/listHelpers";
import { useResponsiveHelper } from "@myinnsworth/hooks/responsiveHelperHook";

export default function LatestNews() {
    const dashboardContext = useOutletContext<DashboardLayoutContext>();
    const [items, setItems] = useState<Array<ICardProps>>([]);
    const nav = useNavigate();
    const {isResponsive} = useResponsiveHelper();

    const onFileItemReadMore = useCallback(async (article: INewsArticle) => {
        const url = await filesHttpService.getViewUrlFromFileId(article.fileId!);
        if(url !== null) {
            if(isResponsive) {
                nav(url);
            } else {
                window.open(url, '_blank');
            }
        }
    }, [isResponsive, nav]);

    const searchNews = useCallback(async () => {
        try {
            const results = await newsHttpService.search({
                orderDir: dashboardContext.sortDirection,
                search: dashboardContext.searchTerm
            });
            setItems(results.results.map(x => {
                return {
                    date: x.publishDate!,
                    title:  x.title!,
                    excerpt: x.excerpt!,
                    imageUrl: x.imageUrl!,
                    readMoreUrl: x.type! === NewsArticleType.Internal ? 
                            `/dashboard/latest-news/${x.id}` : 
                        x.type! === NewsArticleType.File ?
                            () => onFileItemReadMore(x) :
                        x.externalUrl!,
                    isInternalUrl: x.type === NewsArticleType.Internal,
                    noImagePlaceholder: noNewsPlaceholder
                };
            }));
        } catch { }
    }, [dashboardContext.sortDirection, dashboardContext.searchTerm, onFileItemReadMore]);

    useEffect(() => { searchNews(); }, [searchNews]);

    return (
        <div className="news-container">
            <div className="news-inner-container">
                {dashboardContext.listMode === ListMode.Cards && (<InnsworthSlider cards={items} />)}
                {dashboardContext.listMode === ListMode.List && (<InnsworthList cards={items} />)}
            </div>
        </div>
    )
}